// Recovered compiled webpack factory 26381. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return Array.isArray(e) ? e[1] : e;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getSegmentValue", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
